export const CALL_INVOICE_FIELDS: Record<string, {label: string; section: string}> = {
    name: {label: 'callInvoiceConfiguration.name', section: 'scope'},
    billingDirection: {label: 'callInvoiceConfiguration.recipients', section: 'scope'},
    tenant: {label: 'callInvoiceConfiguration.group', section: 'scope'},
    partnerCodes: {label: 'callInvoiceConfiguration.affiliates', section: 'scope'},
    product: {label: 'callInvoiceConfiguration.products', section: 'scope'},
    typeTransaction: {label: 'callInvoiceConfiguration.transaction', section: 'calculation'},
    statusCommandsByProduct: {label: 'callInvoiceConfiguration.includedStatuses', section: 'calculation'},
    typeDate: {label: 'callInvoiceConfiguration.referenceDate', section: 'calculation'},
    billingFrequency: {label: 'invoicing.common.frequency', section: 'periods'},
    rangeDateStart: {label: 'callInvoiceConfiguration.firstPeriod', section: 'periods'},
    rangeDateEnd: {label: 'callInvoiceConfiguration.lastPeriod', section: 'periods'},
    invoiceGenerationDayOfMonth: {label: 'callInvoiceConfiguration.automaticDay', section: 'periods'},
    alertEmailRecipients: {label: 'callInvoiceConfiguration.alerts', section: 'documents'},
    bccEmailRecipients: {label: 'callInvoiceConfiguration.bccRecipients', section: 'documents'},
    sendingblueTemplate: {label: 'callInvoiceConfiguration.template', section: 'documents'},
    invoiceTitle: {label: 'callInvoiceConfiguration.invoiceTitle', section: 'documents'},
    statementSuffix: {label: 'callInvoiceConfiguration.suffix', section: 'advanced'},
    amountMode: {label: 'callInvoiceConfiguration.totalLabel', section: 'advanced'}
};
